import { Route, Routes } from 'react-router-dom';
import { Landing } from './pages/Landing.js';
import { WizardPage } from './pages/WizardPage.js';
import { PlanPage } from './pages/PlanPage.js';
import { ResultsPage } from './pages/ResultsPage.js';
import { SiteHeader } from './components/shared/SiteHeader.js';

export function App() {
  return (
    <div className="min-h-screen bg-surface-page text-text-primary">
      <SiteHeader />
      <main className="mx-auto max-w-3xl px-5 pb-20">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/plan" element={<WizardPage />} />
          <Route path="/plan/results" element={<PlanPage />} />
          <Route path="/plan/:planId" element={<ResultsPage />} />
          <Route path="*" element={<Landing />} />
        </Routes>
      </main>
      <footer className="mx-auto max-w-3xl px-5 py-8 text-center text-sm text-text-muted">
        From Good Circle Marketing. Built for the Spring Challenge.
      </footer>
    </div>
  );
}
